<!-- 商品详情  -->
<template>
  <body>
    <div
      class="ui-detail-swiper"
      v-bind:class="{
        'hide-promotion-bottom': ispromotion,
        'has-goods-stock': isStock <= 0,
      }"
    >
      <product-info
        @mbBodytop="getmbBodytop"
        @reviewtop="getreviewtop"
      ></product-info>
    </div>
  </body>
</template>

<script>
import ProductInfo from "./child/ProductInfo";
import ProductDesc from "./child/ProductDesc";
import ProductReview from "./child/ProductReview";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },

  props: ["isStock"],

  components: {
    ProductInfo,
    ProductDesc,
    ProductReview,
  },

  computed: {
    ...mapState({
      ispromotion: (state) => state.goodsdetail.ispromotion,
    }),
  },

  watch: {},

  mounted() {},

  created() {},

  methods: {
    ...mapMutations({}),
    getmbBodytop: function (top) {
      this.$emit("mbBodytop", top);
    },
    getreviewtop: function (top) {
      this.$emit("reviewtop", top);
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  width: 100%;
  background-color: transparent;
  position: fixed;
  top: 100px;
  height: 100vh;
  overflow-y: auto;
  // z-index: 200;
}
.ui-detail-swiper {
  position: absolute;
  -webkit-overflow-scrolling: touch;
  // height: 90vh;
  // top: 96px;
  bottom: $footerHeight;
  left: 0;
  right: 0;
  overflow: auto;
  z-index: 0;
  position: relative;
  padding-bottom: 100px;

  &.hide-promotion-bottom {
    bottom: 0;
  }
}
</style>
